export const PAGE_TYPE = 'ListingAgents';
